import { ContractsValueObjectsContractScheduleEnum } from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { ContractSchedule } from './graphqlContractVersionSchedule'

const scheduleDescriptionMap: Record<
  ContractsValueObjectsContractScheduleEnum,
  (effectiveOnFormatted: string) => string
> = {
  [ContractSchedule.expired]: (effectiveOnFormatted: string) =>
    i18n.t('contract_versions.header.effective_on_tooltip', {
      effectiveOn: effectiveOnFormatted,
    }),
  [ContractSchedule.ongoing]: (effectiveOnFormatted: string) =>
    i18n.t('contract_versions.header.effective_since_tooltip', {
      effectiveOn: effectiveOnFormatted,
    }),
  [ContractSchedule.upcoming]: (effectiveOnFormatted: string) =>
    i18n.t('contract_versions.header.effective_from_tooltip', {
      effectiveOn: effectiveOnFormatted,
    }),
}

export function getScheduleDescription(
  schedule: ContractsValueObjectsContractScheduleEnum,
  effectiveOn: string
): string {
  const effectiveOnFormatted = i18nDateToString(
    stringToDate(effectiveOn, 'backend'),
    'ui_abbreviated_month_year'
  )

  return scheduleDescriptionMap[schedule](effectiveOnFormatted)
}
